const namespace = 'bravissimo/contact-request';

export const CONTACT_REQUEST = `${namespace}/CONTACT_REQUEST`;
export const CONTACT_REQUEST_SUCCEEDED = `${namespace}/CONTACT_REQUEST_SUCCEEDED`;
export const CONTACT_REQUEST_FAILED = `${namespace}/CONTACT_REQUEST_FAILED`;

export const RECEIVE_ENQUIRY_TEMPLATES = `${namespace}/RECEIVE_ENQUIRY_TEMPLATES`;
export const SELECT_ENQUIRY_TEMPLATE = `${namespace}/SELECT_ENQUIRY_TEMPLATE`;
